import { useQuery } from "@tanstack/react-query";
import { AlertTriangle, ArrowRight, ShieldCheck } from "lucide-react";
import { StatusPill } from "@ocs/ui";
import { adminApi } from "../api";
import { amount, shortAddress } from "../format";

type Dashboard = {
  treasury: { usdt_balance: string; block_number: string; snapshot_at: string } | null;
  liquidity: Array<Record<string, string | number>>;
  updatedAt: string;
};

export function LiquidityPage() {
  const query = useQuery({ queryKey: ["admin-dashboard"], queryFn: () => adminApi<Dashboard>("/dashboard"), refetchInterval: 5000 });
  const direct = query.data?.liquidity.find((item) => Number(item.address_type) === 2);
  const hasUnverifiedFunds = Number(direct?.unverified_liquidity_amount ?? 0) > 0;
  return (
    <div className="liquidity-page">
      <section className="funding-path">
        <div><span>TP Wallet 多签</span><strong>{amount(query.data?.treasury?.usdt_balance)} USDT</strong></div>
        <ArrowRight />
        <div><span>直推收益合约可用流动性</span><strong>{amount(direct?.available_liquidity as string | undefined)} USDT</strong></div>
      </section>
      <section className="liquidity-calculation">
        <header><div><p className="eyebrow">CONFIRMED BLOCK {direct?.block_number ?? "—"}</p><h2>归集调拨流动性覆盖计算</h2></div><StatusPill tone={hasUnverifiedFunds || Number(direct?.liquidity_status) === 3 ? "danger" : Number(direct?.liquidity_status) === 2 ? "warning" : "success"}>{hasUnverifiedFunds ? "发现非归集资金" : Number(direct?.liquidity_status) === 3 ? "资金不足" : Number(direct?.liquidity_status) === 2 ? "低于缓冲" : "覆盖充足"}</StatusPill></header>
        <dl>
          <div><dt>链上 USDT Balance</dt><dd>{amount(direct?.usdt_balance as string | undefined)}</dd></div>
          <div><dt>归集地址累计净调拨</dt><dd>{amount(direct?.authorized_liquidity_balance as string | undefined)}</dd></div>
          <div><dt>未验证资金（不可用）</dt><dd>{amount(direct?.unverified_liquidity_amount as string | undefined)}</dd></div>
          <div><dt>已提交未确认预留</dt><dd>− {amount(direct?.reserved_payout_amount as string | undefined)}</dd></div>
          <div className="subtotal"><dt>当前可用流动性</dt><dd>{amount(direct?.available_liquidity as string | undefined)}</dd></div>
          <div><dt>待处理提现</dt><dd>{amount(direct?.pending_withdrawal_amount as string | undefined)}</dd></div>
          <div><dt>安全缓冲</dt><dd>+ {amount(direct?.safety_buffer_amount as string | undefined)}</dd></div>
          <div className="subtotal"><dt>目标流动性</dt><dd>{amount(direct?.required_liquidity as string | undefined)}</dd></div>
        </dl>
        <div className="transfer-recommendation"><AlertTriangle /><div><span>建议多签调拨金额</span><strong>{amount(direct?.suggested_transfer_amount as string | undefined)} USDT</strong><small>仅为数据建议，不会自动创建或执行多签交易。</small></div></div>
      </section>
      <footer className="freshness-row"><ShieldCheck size={16} />同一确认区块计算 · {direct?.snapshot_at ? new Date(String(direct.snapshot_at)).toLocaleString("zh-CN", { hour12: false }) : "等待 Indexer 首个快照"} · {shortAddress(direct?.address as string | undefined)}</footer>
    </div>
  );
}
